import {c} from 'ttag';

import {TaxCombination, TaxType} from './tax';

const TAX_TYPE_LONG_LABELS: Record<TaxType, () => string> = {
    duty_free: () => c('tax').t`Duty Free`,
    legacy_no_tax: () => c('tax').t`(Legacy) No Tax`,
    legacy_tax: () => c('tax').t`(Legacy) Taxed`,
    non_taxable: () => c('tax').t`Non-taxable`,
    reduced: () => c('tax').t`Reduced`,
    standard: () => c('tax').t`Standard`,
    untaxable: () => c('tax').t`Untaxable`,
};

export const taxTypeLabel = (taxType: TaxType): string =>
    TAX_TYPE_LONG_LABELS[taxType]();

export const taxCombinationLabel = ({
    isTaxInclusive,
    taxRate,
    taxType,
}: TaxCombination): string => {
    const taxRateLabel = `${taxRate}%`;

    if (taxType === 'standard') {
        if (isTaxInclusive) {
            return c('tax').t`Standard ${taxRateLabel} Inclusive`;
        }

        return c('tax').t`Standard ${taxRateLabel} Exclusive`;
    }

    if (taxType === 'reduced') {
        if (isTaxInclusive) {
            return c('tax').t`Reduced ${taxRateLabel} Inclusive`;
        }

        return c('tax').t`Reduced ${taxRateLabel} Exclusive`;
    }

    if (taxType === 'non_taxable') {
        return c('tax').t`Non-taxable`;
    }

    if (taxType === 'untaxable') {
        return c('tax').t`Untaxable`;
    }

    if (taxType === 'duty_free') {
        return c('tax').t`Duty-free`;
    }

    if (taxType === 'legacy_tax') {
        if (isTaxInclusive) {
            return c('tax').t`${taxRateLabel} Inclusive`;
        }

        return c('tax').t`${taxRateLabel} Exclusive`;
    }

    if (taxType === 'legacy_no_tax') {
        return c('tax').t`Non-taxable`;
    }

    throw new Error(`Unknown tax type: ${taxType}`);
};
